export default [
  {
    path: '/country',
    component: () => import('@/views/country/countryList.vue')
  }
];
